import { SearchInput } from '../shared';
import { SortOrder, CargoIntegrationSortType } from '../enums';

export class GetCargoIntegrationsInput extends SearchInput<CargoIntegrationSortType> {
    constructor() {
        super(CargoIntegrationSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}